// Shared accent palette for the method-journey surface.
// Imported by MethodJourney (phase cards) and PhaseDetail (lesson
// rows) so the per-phase tint / stroke / ink stays in sync.

export const ACCENTS = {
  rose: {
    tint:      'rgba(227,161,147,0.18)',
    tintFaint: 'rgba(251,234,231,0.7)',
    stroke:    'rgba(201,122,104,0.45)',
    shadow:    'rgba(201,122,104,0.35)',
    inkStrong: '#a85c4b',
  },
  sage: {
    tint:      'rgba(195,208,185,0.35)',
    tintFaint: 'rgba(195,208,185,0.22)',
    stroke:    'rgba(135,152,124,0.5)',
    shadow:    'rgba(135,152,124,0.35)',
    inkStrong: '#5f7856',
  },
  mauve: {
    tint:      'rgba(207,168,184,0.35)',
    tintFaint: 'rgba(240,223,229,0.7)',
    stroke:    'rgba(156,110,129,0.45)',
    shadow:    'rgba(156,110,129,0.35)',
    inkStrong: '#7d4e65',
  },
  gold: {
    tint:      'rgba(230,200,154,0.35)',
    tintFaint: 'rgba(245,228,196,0.7)',
    stroke:    'rgba(185,143,82,0.5)',
    shadow:    'rgba(185,143,82,0.35)',
    inkStrong: '#8a6a38',
  },
  deep: {
    tint:      'rgba(139, 74, 90, 0.22)',
    tintFaint: 'rgba(251,234,231,0.55)',
    stroke:    'rgba(107, 56, 73, 0.55)',
    shadow:    'rgba(107, 56, 73, 0.45)',
    inkStrong: '#6b3849',
  },
};
